import React from 'react';
import '../../../Statics/Scss/Pages/yaSosSuscriptor.scss';
import Text from '../../Common/common/src/text/Text';
import classNames from 'classnames';

const PhoneBannerSuscription = () => {
    const PhoneBannerAlert = classNames('phone-banner alert');

    return (
        <div className={PhoneBannerAlert}>
            <Text className="--mb-16 fontSizeSuscription --arial">
                Si tenés alguna duda, por favor comunicate al <strong> (011) 5199-4787</strong> de Lunes a Viernes de 8:00 a 20:00hs.
            </Text>
            <Text className="fontSizeSuscription --arial">
                O si estás en el exterior envíanos un mail a: <span>accesodigital@lanacion.com.ar</span>{' '}
            </Text>
        </div>
    );
};

export default PhoneBannerSuscription;